<div class="submenu">
  <a
    class="menu-item"
    routerLinkActive="active"
    routerLink="/landing/registration/select-eds"
    translate
    >login.sign</a
  >

  <a class="menu-item" routerLinkActive="active" routerLink="/landing/registration/add-phone">
    {{ 'registration.sms' | translate }}
    <span class="grey-text">{{ 'registration.sms.individual' | translate }}</span>
  </a>
</div>
